import { api } from "../Configurations/axios";
import { CompanyStageFinepModel } from "../Models/CompanyStageFinepModel";

const GetCompanyStageFinep = async (id: string) => {
    try {
        var result = await api.get(`/CompanyStageFINEP/GetByCompanyFINEPId/${id}`);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateCompanyStageFinep = async (company: CompanyStageFinepModel) => {
    try {
        var result = await api.post(`/CompanyStageFINEP/CreateCompanyStageFINEP`, company);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const EditCompanyStageFinep = async (company: CompanyStageFinepModel) => {
    try {
        var result = await api.put(`/CompanyStageFINEP/UpdateCompanyStageFINEP`, company);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateCompanyStageFinepProps {
    id: string;
    isContentValid: boolean;
    userEmail: string;
}


const ValidateCompanyStageFinep = async (company: ValidateCompanyStageFinepProps) => {
    try {
        var result = await api.put(`/CompanyStageFINEP/ValidateCompanyStageFINEP`, company);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetCompanyStageFinep,
    CreateCompanyStageFinep,
    EditCompanyStageFinep,
    ValidateCompanyStageFinep
}